<template>
  <Container style="height: 80vh" class="bg-white h-screen text-center py-10 justify-center items-center flex flex-col px-4">

    <h1 class="pt-0 pb-8 text-3xl font-extrabold max-w-3xl">
      Jamba powered by Uniti has merged with its parent company, Uniti Internet effective 27 March 2024.
    </h1>
    <h2 class="font-bold text-xl">
      Jamba customers can login to the <a class="underline" href="https://my.unitiinternet.com/">Uniti Internet customer portal</a> using your existing Jamba login details.
    </h2>
    <h2 class="font-bold text-xl pt-2">
      You will be redirected to Uniti Internet in 20 seconds or <a class="underline" href="https://unitiinternet.com?from=jam">click here.</a>
    </h2>
  </Container>
</template>

<script lang="ts" setup>
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import router from '@/router';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import { Brand } from '@/services/integration/enums';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

// Data.
// Event handlers.
const unitiRedirect = async () => {
  if (brandService.getName() === Brand.JAM) {
    setTimeout(() => {
      window.location.href = 'https://unitiinternet.com?from=jam';
    }, 22000);
  } else {
    router.push('/');
  }
};

unitiRedirect();
</script>
